// hooks/useTokenValidation.ts
import { useEffect, useState } from "react";
import { validateToken } from "../../../components/Globais";

export const usePermissao = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState<boolean | null>(null);

  // UseEffect de verificação se o usuário logado tem permissão para acessar a pagina

  useEffect(() => {
    const fetchTokenValidation = () => {
      const Token = validateToken();
      if (!Token) {
        document.location.href = "/login"; // Redireciona se não houver token
        setIsValid(false);
      } else if (Token.nda === 0) {
        document.location.href = "/sempermissao"; // Redireciona se não tiver permissão
        setIsValid(false);
      } else {
        setIsValid(true); // Token é válido
      }
      setIsLoading(false); // Finaliza o carregamento
    };

    fetchTokenValidation();
  }, []);

  return { isLoading, isValid };
};
